import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { json } from '@newtontechnologies/beey-api-js-client/receivers';
const PAGE_LIMIT = (2 ** 31) - 1;
export const getAllAbbreviations = async (connection) => connection.fetch()
    .url(apiV2.currentUser.abbreviations.url({ skip: 0, count: PAGE_LIMIT }))
    .receive(json()
    .map((data) => data.list)
    .finally(() => 'unexpected'))
    .fetchStrict();
export const addAbbreviation = async (connection, params) => {
    const body = {
        abbreviation: params.abbreviation.trim(),
        text: params.text.trim(),
    };
    return connection.fetch()
        .url(apiV2.currentUser.abbreviations.url())
        .postJson(body)
        .receive(json()
        .finally(() => 'unexpected'))
        .fetchStrict();
};
export const editAbbreviation = async (connection, params) => {
    const body = {
        abbreviationId: params.id,
        abbreviation: params.abbreviation.trim(),
        text: params.text.trim(),
    };
    return connection.fetch()
        .url(apiV2.currentUser.abbreviations.url())
        .putJson(body)
        .receive(json()
        .finally(() => 'unexpected'))
        .fetchStrict();
};
export const deleteAbbreviation = async (connection, abbreviationId) => {
    const body = {
        abbreviationId,
    };
    return connection.fetch()
        .url(apiV2.currentUser.abbreviations.url())
        .deleteJson(body)
        .receive(json()
        .finally(() => 'unexpected'))
        .fetchStrict();
};
export const importCsv = async (connection, batch) => (connection.fetch()
    .url(apiV2.currentUser.abbreviations.batch.url())
    .postJson({ abbreviations: batch })
    .receive(json()
    .finally(() => 'unexpected')))
    .fetchStrict();
